import { shallowTracer } from "@app-services/shallow-tracer.service";
import { IStorageService } from "@interfaces/storage-service.interface";

export class LocalStorageService implements IStorageService {

    public isLocalStorageAvailable: boolean = false;

    constructor() {
        this.checkLocalStorageAvailability();
    }

    public get<Type>(key: string): Type | undefined {
        if (!this.isLocalStorageAvailable) {
            throw Error("Local storage not available");
        }

        const item = localStorage.getItem(key);

        return item
            ? JSON.parse(item)
            : undefined;
    };
    
    public set<Type>(key: string, value: Type): void {
        if (!this.isLocalStorageAvailable) {
            throw Error("Local storage not available");
        }

        localStorage.setItem(key, JSON.stringify(value));
    }

    public commit(): Promise<string | null> {
        return new Promise(() => {
            // Empty promise.
        });
    }

    public remove(key: string): void {
        if (!this.isLocalStorageAvailable) {
            throw Error("Local storage not available");
        }
        
        localStorage.removeItem(key);
    }
    
    public removeItem(key: string): void {

        if (!this.isLocalStorageAvailable) {
            return;
        }
        
        localStorage.removeItem(key);
    }

    public setItem(key: string, value: any): void {

        if (!this.isLocalStorageAvailable) {
            return;
        }

        localStorage.setItem(key, JSON.stringify(value));
    }

    public getItem(key: string): any {

        if (!this.isLocalStorageAvailable) {
            return;
        }

        return localStorage.getItem(key);
    }

    private checkLocalStorageAvailability(): void {

        var test = 'test';
        try {

            localStorage.setItem(test, test);
            localStorage.removeItem(test);

            this.isLocalStorageAvailable = true;
        } catch(e) {
            shallowTracer.warn("Local storage not available...");
            this.isLocalStorageAvailable = false;
        }
    }
}